import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c91f52e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "aria-label"]

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BtnLink',
  props: {
    url: {},
    isDownload: { type: Boolean },
    iconName: {},
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any) {



const props = __props;

const link = ref();

onMounted(() => {
	if (props.isDownload) link.value.setAttribute('download', '');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    ref_key: "link",
    ref: link,
    href: _ctx.url || undefined,
    class: _normalizeClass(['icon-button link', { 'link--disabled': !_ctx.url || _ctx.url === 'null' || _ctx.disabled }]),
    rel: "noopener noreferrer",
    "aria-label": _ctx.ariaLabel,
    "data-ts": "btn-link"
  }, [
    _createElementVNode("span", {
      "data-ts": "icon",
      class: _normalizeClass(`icon-button__icon bx ${_ctx.isDownload ? 'bx-download' : _ctx.iconName}`)
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})